import type * as core from '../../../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.higherEd.research.idc.coreFunctions',
    'resource:data.enums.libraryUserCategory',
    'resource:data.enums.libraryUserCategory.entries.faculty',
    'resource:data.enums.libraryUserCategory.entries.hospitalUsers',
    'resource:data.enums.libraryUserCategory.entries.other',
    'resource:data.enums.libraryUserCategory.entries.student',
    'resource:data.enums.libraryUserCategory.entries.workingGraduateStudent',
    'resource:data.dimensions.libraryFteEstimates',
    'resource:data.dimensions.libraryFteEstimates.entities.estimate',
    'resource:data.dimensions.libraryFteEstimates.entities.estimate.attributes.libraryUserCategory',
    'resource:data.dimensions.libraryFteEstimates.entities.estimate.attributes.library',
    'resource:data.dimensions.libraryFteEstimates.entities.estimate.attributes.idcFunction',
    'resource:data.dimensions.libraryFteEstimates.entities.estimate.attributes.ftes',
    'resource:data.dimensions.libraries',
    'resource:data.dimensions.libraries.entities.library',
  ],
  description: 'TODO',
  name: 'IDC Data - Libraries',
} as const satisfies core.quiver.Package
